module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CNCT ParaOverride-11",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("We stand upon the brink of a precipice. We peer into the abyss—we grow sick and dizzy. Our first impulse is to shrink from the danger. Unaccountably we remain.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Edgar Allan Poe, “The Imp of the Perverse”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681f0b1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook43525.vue
// module id = 78
// module chunks = 0